module.exports = __webpack_public_path__ + "img/1.822e677b.jpg";